import styled from 'styled-components';
import BREAK_POINTS from 'packages/smart-home-support/styling/media-queries';

export interface ProtectItContainerProps {
  imageUrl: string;
}

export default styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  height: 460px;
  background-repeat: no-repeat;
  background-size: cover;
  background-image: ${(props: ProtectItContainerProps) => `url(${props.imageUrl})`};
  background-position: bottom;
  margin-top: 2%;
  margin-left: 2%;
  margin-right: 2%;
  margin-bottom: 1%;
  @media ${BREAK_POINTS.mobileBig} {
    height: 676.95px;
    background-position: center;
    background-size: cover;
  }
  @media ${BREAK_POINTS.tablet} {
    font-size: 28px;
    line-height: 32px;
  }
`;



// WEBPACK FOOTER //
// ./packages/smart-home-support/assets/components/ProtectItContainer.tsx